import { deepEquals } from 'app/infrastructure/js';
import { CompareFieldsData, SubscriberGroupItem } from '../types-store';
import { ExternalMemberFormIds } from 'app/area/subscriber-groups/form/constants';

export const hasChanges = (item?: SubscriberGroupItem, original?: SubscriberGroupItem): boolean => {

  const compare = item?.id !== original?.id ||
    item?.description !== original?.description ||
    item?.selfService !== original?.selfService ||
    item?.disabled?.getTime() !== original?.disabled?.getTime() ||
    compareFields({
      fields: [
        ExternalMemberFormIds.emailAddress,
        ExternalMemberFormIds.name
      ],
      values: item?.externalMembers,
      originalValues: original?.externalMembers
    });

  if (compare) {
    return true;
  }

  const language = ((item ?? {}).language ?? [])
    .filter(languageItem => (languageItem.description ?? '').trim().length > 0);
  const originalLanguage = ((original || {}).language || [])
    .filter(languageItem => (languageItem.description ?? '').trim().length > 0);

  if (language.length !== originalLanguage.length) {
    return true;
  }

  if (language.some(
    languageItem => !originalLanguage.some(
      originalLanguageItem => (languageItem.value ?? '') === (originalLanguageItem.value ?? '') &&
        (languageItem.description ?? '') === (originalLanguageItem.description ?? ''))
  )) {
    return true;
  }

  const longDescription = ((item ?? {}).longDescription ?? [])
    .filter(longDescriptionItem => (longDescriptionItem.description ?? '').trim().length > 0);
  const originallongDescription = ((original || {}).longDescription || [])
    .filter(longDescriptionItem => (longDescriptionItem.description ?? '').trim().length > 0);

  if (longDescription.length !== originallongDescription.length) {
    return true;
  }

  if (longDescription.some(
    longDescriptionItem => !originallongDescription.some(
      originalLongDescriptionItem => (longDescriptionItem.value ?? '') === (originalLongDescriptionItem.value ?? '') &&
        (longDescriptionItem.description ?? '') === (originalLongDescriptionItem.description ?? ''))
  )) {
    return true;
  }

  return false;
};

export const compareFields = <T>(data: CompareFieldsData<T>) => {
  const { fields, values, originalValues } = data;

  const newValues = values?.filter(value =>
    fields
      .map(field => value[field])
      .some(item => !!item) && value);

  return !deepEquals(newValues, originalValues);
};
